import classnames from 'classnames';
import React, {Component} from 'react';
import './Confetti.less';

const ANIMATION_DURATIONS = {
    slow: 3500,
    medium: 2250,
    fast: 1750,
    close: 1750,
    far: 2750,
    crazy: 2500,
    silly: 2500,
    fun: 2000,
};

export default class Confetti extends Component {
    static defaultProps = {
        amount: 8,
        delay: 150,
        colors: [
            '#BCCFE8',
            '#FCEAAF',
            '#F0BEBA',
            '#9CA2D7',
            '#ADDDDF',
            '#E6BFDA',
        ],
        speeds: [
            'slow',
            'medium',
            'fast',
            'close',
            'far',
            'crazy',
            'silly',
            'fun',
        ],
    };

    constructor(props) {
        super(props);
        this.inc = 0;
        this.active = true;
        this.timeouts = [];
    }

    state = {
        items: [],
    };

    componentDidMount() {
        this.tick();
    }

    componentWillUnmount() {
        this.active = false;

        if (this.tickTimeout) {
            window.clearTimeout(this.tickTimeout);
        }

        if (this.timeouts && this.timeouts.length) {
            this.timeouts.forEach((id) => window.clearTimeout(id));
        }

        this.timeouts = [];
    }

    getRandomConfetti = () => {
        const {colors, speeds} = this.props;

        // get random attributes
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        const randomSpeed = speeds[Math.floor(Math.random() * speeds.length)];
        const randomLeft = `${Math.floor(
            Math.random() * this.el.offsetWidth
        )}px`;
        const randomSize = Math.floor(Math.random() * 5) + 7;

        // calc the unique key
        const key = `${this.inc++}-${randomSpeed}-${randomColor}`;

        return {
            height: randomSize,
            width: randomSize * 2,
            left: randomLeft,
            color: randomColor,
            speed: randomSpeed,
            duration: ANIMATION_DURATIONS[randomSpeed],
            key,
        };
    };

    tick = () => {
        const {items} = this.state;
        const {delay, amount} = this.props;

        const newItems = new Array(amount).fill(0).map(() => {
            const newItem = this.getRandomConfetti();
            const timeout = window.setTimeout(
                this.remove(newItem.key),
                newItem.duration
            );
            this.timeouts.push(timeout);
            return {...newItem, timeout};
        });

        if (this.active) {
            this.setState({items: items.concat(newItems)});
            this.tickTimeout = window.setTimeout(this.tick, delay);
        }
    };

    remove = (key) => () => {
        const {items} = this.state;
        const removedItem = items.find((item) => item.key === key);
        const newItems = items.filter((item) => item.key !== key);

        if (this.active) {
            this.setState({items: newItems});
            this.timeouts = this.timeouts.filter(
                (id) => id === removedItem.key
            );
        }
    };

    handleElRef = (node) => {
        this.el = node;
    };

    render() {
        const {items} = this.state;

        return (
            <div className="confetti-container" ref={this.handleElRef}>
                {items.map((item) => {
                    return (
                        <div
                            key={item.key}
                            className={classnames('confetti', item.speed)}
                            style={{
                                left: item.left,
                                width: item.width,
                                height: item.height,
                                backgroundColor: item.color,
                                animationDuration: item.duration,
                            }}
                        />
                    );
                })}
            </div>
        );
    }
}
